export const normalizeSearchString = (s: string) =>
  s
    .toLowerCase()
    .replace(/['']/g, "") // strip apostrophes: Martha's → marthas
    .replace(/[-–—]/g, " ") // hyphens/dashes → spaces: Decker-Lee → Decker Lee
    .replace(/[^a-z0-9\s]/g, "") // strip remaining punctuation
    .replace(/\s+/g, " ") // collapse whitespace
    .trim()
